// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/notification/style/index.css
 ** module id = 1194
 ** module chunks = 0
 **/